import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { apiPrivate } from '../services/api';
import { useAuth } from './AuthContext';

const MonthContext = createContext(null);

export function MonthProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [months, setMonths] = useState([]);
  const [activeMonth, setActiveMonth] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMonths = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiPrivate.get('/api/months');
      const list = res.data;
      setMonths(list);

      const open = list.find((m) => m.status === 'open');
      if (open) {
        setActiveMonth((prev) => prev ?? open);
      } else {
        // Auto-create current month if none exists
        const now = new Date();
        const created = await apiPrivate.post('/api/months', {
          year: now.getFullYear(),
          month: now.getMonth() + 1
        });
        setMonths([created.data, ...list]);
        setActiveMonth(created.data);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      loadMonths();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, loadMonths]);

  return <MonthContext.Provider value={{ months, activeMonth, setActiveMonth, loadMonths, loading }}>{children}</MonthContext.Provider>;
}

export function useMonth() {
  const ctx = useContext(MonthContext);
  if (!ctx) throw new Error('useMonth deve ser usado dentro de MonthProvider');
  return ctx;
}
